// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"d138b393","274":"8ca5e8a0","473":"a78f8238","957":"7b0bacf2"}[chunkId] + ".chunk.js";
};